export default "__VITE_ASSET__BTwVO$RN__"